@for (item of trayItems$ | async; track item.id) {
  <ng-content
    *ngTemplateOutlet="itemTemplateRef || defaultTrayItemTemplate; context: { item: item, close: close, restore: restore }"
  ></ng-content>
}

<ng-template #defaultTrayItemTemplate let-item="item" let-close="close" let-restore="restore">
  <div (click)="restore(item)">
    {{ item.title }}
    <button (click)="close(item)">Close</button>
  </div>
</ng-template>
